





























































































































































































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
//import VueRouter from "vue-router";
import { namespace } from "vuex-class";
import { env } from "@/env";

import { httpClient } from "../../core";

import FilePreviewPopup from "@/views/filepreview/FilePreviewPopup.vue";
import translationsService from "@/services/translations";
import { TranslatedFileModel } from "../../models/file.model";
import ShareObject from '@/components/ShareObject.vue';
import VueI18n from '@/i18n';

const TranslationsStore = namespace("translations");
const TranslateStore = namespace("translate");

@Component({
  name: "TranslationsComponent",
  components: {
    FilePreviewPopup,
    ShareObject
  }
})
export default class TranslationsComponent extends Vue {
  @Prop(String) public documentId: string | undefined;

  private currentDocuments!: TranslatedFileModel[];

  @TranslationsStore.Action
  public fetchTranslations!: () => Promise<any>;
  @TranslationsStore.Getter
  public getTranslatedDocuments!: [];
  @TranslationsStore.Getter
  public isFetchingTranslations!: boolean;

  @TranslationsStore.Action
  public fetchAllDocuments!: () => Promise<any>;
  @TranslationsStore.Getter
  public getAllDocuments!: TranslatedFileModel[];
  @TranslationsStore.Getter
  public isFetchingAllTranslations!: boolean;

  @TranslateStore.Action
  public fetchLanguages!: () => Promise<any>;
  @TranslateStore.Getter
  public getResolvedLanguageName!: (abbr: string) => string;
  @TranslateStore.Getter
  public getTranslateToLanguages!: any[];

  private messageText: string;
  private headers: any[];
  private pagination: any;
  private search: string;
  private showMessage: boolean;
  private messageColor: string;
  private isError: boolean;
  private snackbarText: string;
  private filePreview: {
    show: boolean;
    documentId: string;
    target: string;
    fileName: string;
  };
  private deleteDialog: { show: boolean; documentId: string };
  private shareDialog = {
    show: false,
    item: {objectId: '', objectUrl: '', objectName: ''},
  };
  private showDetail: boolean;
  private doc: TranslatedFileModel;
  private autorefresh = false;
  private autorefreshIntervalId: any = -1;
  public user: any;
  private isGlobal = false;
  private pages = 0;
  private previewRemovalDate: Date = new Date(2026, 1, 28, 23, 59, 59); // February 28, 2026 23:59:59

  constructor() {
    super();
    this.messageText = "";
    this.snackbarText = "";
    this.search = "";
    this.showMessage = false;
    this.messageColor = "";
    this.isError = false;
    this.filePreview = {
      show: false,
      documentId: "-1",
      target: "",
      fileName: ""
    };
    this.deleteDialog = {
      show: false,
      documentId: "-1"
    };
    this.showDetail = false;

    this.headers = [
      { text: "Doc Id", value: "documentId", align: " d-none" },
      { text: "Name", value: "fileName", align: "left", width: "35%" },
      { text: "Status", value: "statusId" },
      { text: "Date", value: "dateTime" },
      { text: "From", value: "sourceLang" },
      { text: "Into", value: "destinationLang" },
      { text: "Model", value: "model" },
      { text: "Actions", value: "actions", align: "center", sortable: false, width: "11%" },
      { text: "Rating", value: "rating", align: "center", sortable: false },
      { text: "Details", value: "details", sortable: false }
    ];
    this.pagination = {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10
    };
    this.doc = {
      documentId: "0",
      fileName: "",
      originalName: "",
      translatedCorrectly: false,
      dateTime: new Date(),
      sourceLang: "",
      destinationLang: "",
      totalBytes: 0,
      totalCharacters: 0,
      statusId: 0,
      model: ''
    };
    this.currentDocuments = [];
  }

  private beforeDestroy(){
    clearInterval(this.autorefreshIntervalId);
  }

  private async mounted() {
    this.user = (this as any).auth.user;
    this.messageText = "Getting translations";
    if (this.getTranslateToLanguages.length === 0) {
      await this.fetchLanguages();
    }

    this.isGlobal = (this.$route.query.mode == 'global');
    if (this.isGlobal) {
      this.getDocuments(); //no autorefresh if global
    }
    else {
      if (!this.filePreview.show) {
        await this.startAutorefresh(); // avoid autorefresh
        // this.getDocuments();
      }
    }

    if (this.documentId) {
      this.search = this.documentId;
      this.$nextTick(() => {
        (this.$refs.afterClick as any).focus();
      });
    }

    window.onkeydown = (e: KeyboardEvent) => {
      if(e.key == 'Escape') this.showDetail = false;
    };
  }

  private async startAutorefresh() {
    clearInterval(this.autorefreshIntervalId);
    const fetchCall = async () => {
      this.getDocuments();
      this.pages = 2; //this.currentDocuments.length;
    };
    await fetchCall();
    this.autorefreshIntervalId = setInterval(async () => {
      if (document.hidden) {
        return;
      }
      if (!this.filePreview.show) {
        this.autorefresh = true;
        await fetchCall();
      }
      this.autorefresh = false;
    }, 30000);
  }

  private getDocuments() {
    this.currentDocuments = [];

    if (this.isGlobal) {

      this.fetchAllDocuments()
        .then(() => {
          this.currentDocuments = this.getAllDocuments;
        })
        .catch((error: any) => {
          this.displayInfo(
            "Error getting ALL translations, you are not authorized... Redirecting to User area",
            error
          );
          setTimeout(() => {
            //this.$router.push('/translations'); //not working to same route with different params
            window.location.replace("/translations");
          }, 2500);
        });
    }
    else {

      this.fetchTranslations()
        .then(() => {
          this.currentDocuments = this.getTranslatedDocuments;
        })
        .catch((error: any) => {
          this.displayInfo(
            "Error getting USER translations, please check your network connection",
            error
          );
        });
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  private onUrlChange(/*newVal: VueRouter*/) {
    this.search = "";
  }

  private giveFeedback(doc: any) {
    this.$router.push('/feedback/' + doc.documentId);
  }

  private async saveRating(documentId: string, rating: number) {
    rating = rating || -1;
    httpClient.instance
      .put(
        `${env.apiUrl}/documents/${env.applicationId}/${documentId}/rate/${rating}`
      )
      .then( () => {
        this.displayInfo("Document rating saved successfully", '');
      })
      .catch(error => {
        this.displayInfo(
          "There was an error updating this document, please try again",
          error
        );
      })
      .finally(async () => {
        this.getDocuments();
      });
  }


  private async downloadFile(
    documentId: string,
    fileName: string,
    target: string
  ) {
    this.displayInfo("Downloading translated document, please wait ...", '');

    try {
      const downloaded = await translationsService.downloadFile(
        documentId,
        fileName,
        target
      );
      if (downloaded) {
        this.displayInfo("File downloaded", '');
      } else {
        throw new Error("download failed");
      }
    } catch (error) {
      this.displayInfo(
        "There was an error downloading this document, please try again",
        error
      );
    }
  }

  private async showSharedDoc(item: any) {
    if (item.documentId === undefined) {
      return;
    }
    this.shareDialog.show = true;
    this.shareDialog.item.objectId = item.documentId;
    this.shareDialog.item.objectName = item.fileName;
  }

  private async removeSharedUser(doc: any, mail: string) {
    // some code
    await httpClient.instance.delete(
      `${env.apiUrl}/documents/${env.applicationId}/shared/${doc.documentId}/remove/${mail}`
    ).then( () => {
      this.displayInfo("User removed from shared list successfully", "");
    })
    .catch(error => {
      this.displayInfo(
        "There was an error removing user from shared list, please try again",
        error
      );
    })
    .finally(async () => {
      this.getDocuments();
      this.showDetail = false;
    });
  }

  private docSharedWith(doc: any): any {
    if (doc.sharedWith.find((mail: string) => mail.toLowerCase() === (this as any).auth.user.userName.toLowerCase())) {
      return null;
    }

    if (doc.sharedWith.length > 0) {
      return doc.sharedWith;
    }

    return null;
  }

  private docSharedFrom(doc: any): string {
    if (doc.sharedFrom.toLowerCase() === (this as any).auth.user.userName.toLowerCase()) {
      return ""
    }

    return doc.sharedFrom;
  }

  private async previewFile(
    documentId: string,
    fileName: string,
    target: string
  ) {
    this.filePreview.documentId = documentId;
    this.filePreview.fileName = fileName;
    this.filePreview.target = target;
    this.filePreview.show = true;
  }

  private displayInfo(text: string, error: string) {
    this.snackbarText = text;
    this.messageColor = error ? 'error' : 'sgsOrange';
    this.showMessage = true;
    this.isError = error.length > 0 ? true : false;
    if (error) console.error(text, error);
  }

  private async retryFile(documentId: string) {
    httpClient.instance
      .post(
        `${env.apiUrl}/queue/${env.applicationId}/${documentId}/retryByDocument`
      )
      .then( () => {
        this.displayInfo("Document sent to retry successfully", '');
      })
      .catch(error => {
        this.displayInfo(
          "There was an error retrying this document, please try again",
          error
        );
      })
      .finally(async () => {
        this.getDocuments();
      });
  }

  private deleteFile(documentId: string) {
    this.deleteDialog.show = true;
    this.deleteDialog.documentId = documentId;
  }

  private confirmDeleteFile(documentId: string) {
    this.deleteDialog.show = false;
    httpClient.instance
      .delete(`${env.apiUrl}/documents/${env.applicationId}/${documentId}`)
      .then( () => {
        this.displayInfo("Document deleted successfully", '');
      })
      .catch(error => {
        this.displayInfo(
          "There was an error deleting this document, please try again",
          error
        );
      })
      .finally(async () => {
        this.getDocuments();
      });
  }

  private getStatus(item: TranslatedFileModel) {
    const statusId = item.statusId;
    if (statusId === 1) {
      return { text: "Complete", color: "green" };
    } else if (statusId >= 10 && statusId <= 11) {
      return { text: "Processing OCR", color: "black" };
    } else if (statusId >= 20 && statusId <= 21) {
      return { text: "Processing", color: "black" };
    } else {
      const title = item.isStatusTooManyCharacters ?
        "Too many characters: if you need more, contact us by clicking the Action feedback icon" : undefined;
      return { text: "Error", color: "red", title };
    }
  }

  private async viewPanel(doc: TranslatedFileModel) {
    httpClient.instance
      .get(
        `${env.apiUrl}/documents/${env.applicationId}/${doc.documentId}/userkey/${doc.userKey}`
      )
      .then((response) => {
        doc.documentSections = response.data.documentSections;
        this.showDetail = true;
        this.doc = doc;
      })
      .catch(error => {
        this.displayInfo("Error getting details, please try again", error);
      })
      ;
  }

  private docIcon(fileName: string) {
    const re: any = /(?:\.([^.]+))?$/;
    let fileNameExtension: string = re.exec(fileName.toLowerCase())[1];
    if (fileNameExtension.endsWith("x")) {
      fileNameExtension = fileNameExtension.substring(0, 3);
    }

    try {
      return require(`../../assets/images/${fileNameExtension}-icon.svg`);
    } catch (error) {
      return require(`../../assets/images/unknown-icon.svg`);
    }
  }

  private canShowPreviewIcon(fileName: string) {
    return !fileName.includes(".msg");
  }

  private totalChars(
    items: Array<{
      sourceLang: string;
      totalCharacters: number;
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      items?: typeof items;
    }>,
    docSourceLang: string
  ): typeof items {
    let total = 0;
    let result: typeof items = [];

    items.forEach((item, i) => {
      if (items.length > 3 && i >= 2) {
        total = total + item.totalCharacters;
      }

      result.push({
        sourceLang: `${this.formatNumber(
          item.totalCharacters
        )} ${VueI18n.t('chars in')} ${this.getResolvedLanguageName(item.sourceLang ?? docSourceLang) ||
          item.sourceLang}`,
        totalCharacters: item.totalCharacters
      });
    });

    if (total > 0) {
      const subItems = result.slice(2);
      const text = `${this.formatNumber(total)} ${VueI18n.t('chars in Other languages')}`;
      result.splice(2, 0, {
        sourceLang: text,
        totalCharacters: total,
        items: subItems
      });
    }

    result = result.slice(0, 3);
    return result;
  }

  private formatNumber(num: number): string {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  private isErrorStatus(statusId: number) {
    return [-1, 19, 29, 39].includes(statusId);
  }

  get canShowDialog(): boolean {
    return (this.isFetchingTranslations || this.isFetchingAllTranslations) && !this.autorefresh;
  }

  private isPreviewAvailable(): boolean {
    return new Date() < this.previewRemovalDate;
  }
}

